import { Component, DoCheck, OnDestroy, OnInit, inject } from '@angular/core';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { RouterState } from 'src/app/features/auth/redux/router-state';
import { Robot } from 'src/app/models/robot';
import { ACTIONS } from 'src/app/shared/constants/general-constants';
import { TIMEZONES } from 'src/app/shared/constants/iana-timezone-constants';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxGenericModalComponent } from 'src/app/shared/ui/ngx-generic-modal/ngx-generic-modal.component';
import { PostRobots, QaState } from '../../redux';

@Component({
  selector: 'app-edit-my-robots',
  templateUrl: './edit-my-robots.component.html',
  styleUrls: ['./edit-my-robots.component.css'],
  standalone: true,
  imports: [SharedModule]
})
export class EditMyRobotsComponent implements OnInit, DoCheck, OnDestroy {
  public robot$: Observable<any[]> = inject(Store).select(QaState.robots);
  public username$: Observable<string> = inject(Store).select(RouterState.username);
  private unsubscribe = new Subject<void>();

  public robot: Robot;
  public action: string;
  public allRobots;
  public owner: string;

  public timezones = TIMEZONES;
  public regDate;
  public errorMsg = '';
  public isEdit = false;
  public now = new Date(); // earliest allowed
  public startDateTime = new Date(); // initial start
  public endDateTime = new Date(this.now.getTime() + 60 * 60 * 1000);
  public dateForDatepickerStart: Date;

  constructor(
    private store: Store,
    protected ref: NbDialogRef<EditMyRobotsComponent>,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  public ngOnInit(): void {
    this.robot$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.allRobots = data));
    this.username$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.owner = data));

    /*
     * It is neccessary to remove the current robot from the list so that
     * ID verification can take place.
     */
    if (this.action != ACTIONS.CLONE) {
      this.allRobots = this.allRobots.filter((robot) => robot.id !== this.robot.id);
    }
    if (this.robot.registration_date) {
      this.dateForDatepickerStart = new Date(this.robot.registration_date * 1000);
    } else {
      this.dateForDatepickerStart = new Date();
    }
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public ngDoCheck() {
    if (this.action === ACTIONS.EDIT) {
      this.isEdit = true;
    }
  }

  public onStartChange(newStart: Date) {
    this.startDateTime = newStart;
    if (this.endDateTime.getTime() < newStart.getTime()) {
      this.endDateTime = new Date(newStart.getTime());
    }
  }

  public uniqueRobotID(): boolean {
    return this.allRobots.filter((robot) => robot.id === this.robot.id).length === 0;
  }

  public save() {
    if (this.uniqueRobotID()) {
      this.robot.registration_date = parseInt((new Date(this.dateForDatepickerStart).getTime() / 1000).toFixed(0), 10);
      this.robot.family = this.robot.sku.slice(0, 2);
      this.robot.owner = this.owner;
      this.store.dispatch(new PostRobots(this.robot, this.isEdit));
      this.ref.close();
    } else {
      this.toastrService.show(status, $localize`Robot ID has to be unique!`, { status: 'danger' });
    }
  }

  public close() {
    this.dialogService
      .open(NgxGenericModalComponent, {
        context: {
          title: $localize`Confirm Close`,
          message: $localize`Are you sure that you want to close the window? Any changes that you have made will be lost.`
        }
      })
      .onClose.subscribe((data) => {
        if (data) {
          this.ref.close();
        }
      });
  }
}
